import { alarmOf, statusOf } from '../utils/floorStatus';

const THEMES = {
  'RUNNING':     { label: 'RUNNING',     hex: '#2E7D5E', pixi: 0x2e7d5e },
  'SETUP':       { label: 'SETUP',       hex: '#A89060', pixi: 0xa89060 },
  'STARVED':     { label: 'STARVED',     hex: '#B7791F', pixi: 0xb7791f },
  'TOOL CHANGE': { label: 'TOOL CHANGE', hex: '#B7791F', pixi: 0xb7791f },
  'FAULTED':     { label: 'FAULTED',     hex: '#C0392B', pixi: 0xc0392b },
  'HELD':        { label: 'HELD',        hex: '#B7791F', pixi: 0xb7791f },
  'COMPLETE':    { label: 'COMPLETE',    hex: '#8BA0B5', pixi: 0x8ba0b5 },
  'IDLE':        { label: 'IDLE',        hex: '#4A5568', pixi: 0x4a5568 },
  'NO DATA':     { label: 'NO DATA',     hex: '#4A5568', pixi: 0x4a5568 },
};

export function stationVisual(stationState) {
  if (!stationState?.present || !stationState.live) {
    return { ...THEMES['NO DATA'], present: false, live: null, alarm: null };
  }
  const status = statusOf(stationState.live, null);
  const theme = THEMES[status.label] || THEMES.IDLE;
  return {
    ...theme,
    present: true,
    live: stationState.live,
    alarm: alarmOf(stationState.live, null),
  };
}

export function stationPartCount(stationState) {
  const live = stationState?.live;
  return live?.running?.partCount
    ?? live?.dispatched?.completedQty
    ?? 0;
}

export function stationProgram(stationState) {
  const live = stationState?.live;
  return live?.running?.program
    ?? live?.dispatched?.program
    ?? null;
}

export function stationCycleProgress(stationState) {
  const v = stationState?.live?.running?.cycleProgress;
  return Number.isFinite(Number(v)) ? Number(v) : null;
}
